import gsap from "gsap";
import { $, $$, on } from "./dom";

export function initCursor() {
  const cursor = $("#cursor");
  const labelEl = $("[data-cursor-label]");
  if (!cursor || !labelEl) return;

  const pos = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
  const target = { ...pos };

  on<MouseEvent>(window, "pointermove", (e) => {
    target.x = e.clientX;
    target.y = e.clientY;
  });

  gsap.ticker.add(() => {
    pos.x += (target.x - pos.x) * 0.18;
    pos.y += (target.y - pos.y) * 0.18;
    cursor.style.transform = `translate3d(${pos.x}px, ${pos.y}px, 0) translate(-50%, -50%)`;
  });

  // Wire up hover targets — re-run after each route change
  const cursorEl = cursor;
  const label = labelEl;
  const refresh = () => {
    $$<HTMLElement>("[data-cursor], a, button").forEach((node) => {
      if (node.dataset.cursorWired) return;
      node.dataset.cursorWired = "1";
      const customLabel = node.dataset.cursorLabel;
      const mode = node.dataset.cursor ?? (customLabel ? "label" : "hover");
      node.addEventListener("pointerenter", () => {
        cursorEl.dataset.cursor = mode;
        if (customLabel) label.textContent = customLabel;
      });
      node.addEventListener("pointerleave", () => {
        cursorEl.removeAttribute("data-cursor");
      });
    });
  };

  refresh();
  return { refresh };
}
